
let lang = {
  isChina: 1,
  home: '首页',
  kczx: '课程中心',
  xzapp: '下载app',
  xxdt: '学习大厅',
  articles: '热点资讯',
  appTip: '温馨提示：安卓APP请使用浏览器扫码，安装[伊课网校]APP后，请搜索选择当前网校名称后进入使用',
  xsapp: '学生端APP',
  downloadTip: '上课更方便，学习更效率',
  android: '安卓APP下载',
  ios: '苹果APP下载',
  browser: '浏览器下载',
  browserTip: '为保证上课稳定，推荐使用以下浏览器',
  google: '谷歌浏览器',
  firefox: '火狐浏览器',
  browser360: '360浏览器',
  browserqq: 'QQ浏览器',
  lxkf: '联系客服',
  help: '使用帮助',
  kczxun: '课程咨询',
  hddb: '回到顶部',
  kfdh: '客服电话：',
  kfqq: '客服QQ：',
  nohelp: '当前没有帮助文档',
  exit: '是否退出登录？',
  tips: '提示',
  define: '确定',
  cancel: '取消',
  my_course: '我的课程',
  grzl: '个人资料',
  safe_exit: '安全退出',
  login: '登录',
  reg: '注册',
  sign_up: '登录/注册',
  logining: '登录中',
  account_login: '账号登录',
  code_login: '验证码登录',
  password_login: '密码登录',
  remember: '记住账号',
  retrieve: '找回密码',
  msg_sent: '已成功发送短信，请查收',
  msg_sent1: '验证码已发送您的手机，请查收',
  msg_sent2: '验证码已发送您的邮箱，请查收',
  get_code: '获取验证码',
  apply_again: '后重新获取',
  account_tip: '您已经注册过账号，是否前往登录',
  input_num: '请输入手机号码',
  check_num: '手机号格式错误，请检查',
  check_num1: '手机号或邮箱格式错误，请检查',
  enter_code: '请输入验证码',
  type_characters: '请输入图中的字符',
  account: '请输入账号',
  password: '密码',
  enter_password: '请输入密码',
  correct_password: '请输入正确的密码',
  submit: '提 交',
  phone: '手机号',
  phone_email: '请输入邮箱/手机号',
  phone_email_tip: '请输入注册邮箱或中国大陆手机号',
  bind_phone: '绑定账号',
  code: '验证码',
  tobind: '您已经注册过账号，是否前往绑定',
  agreement: '请同意用户协议、隐私条款和儿童隐私协议',
  read_agree: '我已阅读并同意',
  user_agreement: '《用户协议》、',
  privacy_terms: '《隐私条款》、',
  child_agreement: '《儿童隐私协议》',
  read_agree1: '，未注册绑定的手机号验证成功后将自动注册。',
  noreg: '您还没有注册，是否立即前往注册',
  graphical_code: '请输入图形验证码',
  noclearly: '看不清楚',
  change_one: '看不清？换一个',
  passwords: '8-20位字母和数字密码',
  passwordsTip: '8-20位，且包含数字，字母，符号中的任意两种组合',
  log_now: '已有账号？立即登录',
  have_account: '您已经注册过账号，是否立即前往登录',
  center_address: '体验中心地址：',
  hotline: '服务热线：',
  forgot_password: '忘记密码',
  new_password: '新密码',
  enter_new_password: '请输入新密码',
  nouser: '用户不存在',
  password_reset: '密码修改成功',
  recommend: '推荐',
  all_recommended: '全部推荐',
  vip: '会员专区',
  enter_interested: '请输入感兴趣的内容',
  search: '搜索',
  nologging: '未登录，登录后可查看更多',
  log_in_now: '立即登录',
  my_favorite: '我的点赞',
  my_collection: '我的收藏',
  like: '点赞',
  liked: '已点赞',
  collect: '收藏',
  collected: '已收藏',
  no_data: '暂无数据',
  no_course: '暂无课程',
  wszl: '完善资料让讲师更了解你～',
  nick_name: '昵称',
  birthday: '生日',
  select_date: '选择日期',
  time_zone: '时区',
  complete_later: '稍后完善',
  save_data: '保存资料',
  city: '城市',
  live_class: '直播课',
  learn_anytime: '随到随学',
  city_tip: '请选择您所在的城市',
  time_zone_tip: '请选择您的时区',
  birthday_tip: '请设置您的生日',
  nick_name_tip: '请填写昵称',
  unread: '您的站内信有未读消息，点击查看！',
  enter_course: '请输入要搜索的课程名称',
  choose_class: '请选择赠课',
  saved: '保存成功',
  your_grade: '您的年级',
  select_grade: '请选择年级',
  choose_course: '请选择课程',
  new_comers: '新人专享',
  free_class: '恭喜获得免费赠课',
  next_time: '下次再说',
  get_it_now: '立即领取',
  interested_courses: '您感兴趣的课程是',
  next: '下一步',
  save: '保 存',
  confirm_time_zone: '确认时区通知',
  confirm_time_zone_data: '您好，您的默认时区为北京（UTC+08:00）的时区，为了提升您的上课体验，请点击下方按钮前往确认时区或者修改时区。',
  go_modify: '前往修改',
  free_lessons: '以下是我们为您挑选的赠课',
  change_batch: '换一批',
  free: '免费',
  no_accessed: '当前学科暂无课程领取…',
  step: '请返回上一步',
  no_need: '不用了，谢谢',
  gift: '领取赠课',
  received_succeed: '领取成功',
  invite: '邀请好友还能获取更多免费赠课哦',
  click_more: '去看看',
  all: '全部',
  mon_fri: '周一至五',
  sat: '周六',
  sun: '周日',
  in_progress: '进行中',
  ended: '已结束',
  full: '已报满',
  discontinued: '已停售',
  stop_selling: '后截止售卖',
  no_started: '未开始',
  categories: '分类：',
  subject: '科目：',
  time: '时间：',
  type: '类型：',
  state: '状态：',
  unlock_time: '解锁时间：',
  lecturer: '讲师：',
  comments: '评价',
  star: '星',
  cpbm: '测评后报名',
  ljbm: '立即报名',
  purchased: '已购买',
  fdgm: '分段购买',
  yfdgm: '已分段购买',
  course_introduction: '课程简介',
  chapter_list: '章节列表',
  comment: '课程评价',
  course_evaluation: '课程评价',
  take_course: '如何上课',
  chapter_list_tip: '已结束课程可在报名后观看回放',
  take_course_tit1: '1、选课',
  take_course_tit2: '2、下载浏览器',
  take_course_tit3: '3、上课',
  take_course_tit4: '4、完成练习',
  take_course_con1: '在网页或者APP选择感兴趣的课程',
  take_course_con2: '下载浏览器准备上课',
  take_course_con3: '上课前15分钟进入教室，课后可反复观看回放',
  take_course_con4: '课后记得完成随堂练习，讲师会在下一节课进行错题讲解哦',
  go_download: '去下载',
  no_course_sale: 'TA暂时没有在售的课程哦',
  grade1: '年级：',
  education: '学历：',
  teaching_age: '教龄：',
  lecturer_profile: '讲师详情',
  course_purchase: '课程购买',
  buy_fdgm: '订单信息 (分段购买)',
  buy_qkgm: '订单信息 (全课购买)',
  existing_course: '已有课程',
  purchase_courses: '购买课程',
  see_more: '查看更多',
  buy_tip1: '购买前请阅读',
  buy_tip2: '《购买课程声明》',
  buy_tip3: '了解规则',
  confirm_purchase: '确认购买',
  read_agreement: '我已阅读并知晓协议',
  think_about_it: '考虑一下',
  following_courses: '您确定要购买以下课程么：',
  need_to_pay: '需支付',
  discount: '折扣：',
  original_price: '原价：',
  lbls: '门课程联报立省',
  more_lb: '更多优惠联报',
  buy_now: '立即抢购',
  yhlb: '优惠联报',
  current_price: '现价：',
  evaluation: '测评',
  full_score: '满分',
  points: '分',
  dtsj: '答题时间',
  minute: '分钟',
  start_ass: '开始测评',
  overall_score: '测评总分',
  cpts: '测评题数',
  question: '题目',
  options: '选项',
  correct: '对',
  wrong: '错',
  unanswered: '未答题',
  answered: '已答题',
  submit_answer: '提交答案',
  time_remain: '剩余时间：',
  unfinished: '您还有未完成的题',
  re_do: '重新做题',
  head_purchase: '前往购买',
  back_course: '返回课程列表',
  student: '学员',
  unbuy1: '您的得分 < ',
  unbuy2: '分，不能报此课程，去看看别的课程吧',
  can_buy1: '您的得分 >= ',
  can_buy2: '分，可以报此课程',
  assessment_results: '测评结果',
  assessment_score: '测评分数',
  correct_rate: '正确率',
  time_use: '答题用时',
  msg_center: '消息中心',
  system_info: '系统消息',
  feedback: '意见反馈',
  provide_feedback: '反馈建议',
  msg_read: '全部标记为已读',
  title: '标题',
  states: '状态',
  sand_time: '发送时间',
  have_read: '已读',
  un_read: '未读',
  your_opinion: '您的意见是我们前进的最大动力，对您的配合和支持表示衷心感谢',
  all_read: '确认将全部未读消息变为已读吗?',
  send_it: '确认发送吗',
  thank_feedback: '感谢您的反馈及建议，我们会及时处理！',
  details: '详情',
  reply: '回复',
  incomplete: '未完成测评练习',
  all_reviews: '查看全部测评',
  exercises_no_finish: '目前没有待完成练习',
  submitted_pass: '已过提交时间',
  practice_grated: '可作答 不予批改',
  complete_exercise: '完成练习',
  deadline_submit: '截至提交时间：',
  related_exercises: '课后练习',
  curriculum: '课程列表',
  search_courses: '搜索课程',
  eva_tip: '请准时完成练习',
  eva_tip1: '，截止时间：',
  eva_tip2: '2. 讲师会在下一节课对错误较多的题目进行讲解，请认真完成',
  exam_analysis: '试题分析：',
  find_reason: '成绩不理想？找找错误的原因',
  score: '得分',
  view_all: '查看全部',
  collapse_content: '收起内容',
  time_submission: '提交时间',
  lec_correction: '讲师批改',
  attachment: '附件：',
  answer_question: '答题',
  word: '文字',
  picture: '图片',
  recording: '录音',
  video: '视频',
  audio: '音频',
  document: '文档',
  remove_document: '移除文档',
  enter_text: '请输入文字',
  start: '开始',
  pause: '暂停',
  continute: '继续',
  stop: '停止',
  del_record: '您确定要删除录音',
  del: '删除',
  success_del: '删除成功!',
  page_microphone: '请先允许该网页使用麦克风',
  img9: '最多可以上传9张图片!',
  img_type: '只能上传jpg,png等格式!',
  mb3: '请上传不超过3MB的文件!',
  mp4: '只允许上传mp4文件!',
  mb100: '文件大小不允许超过100MB!',
  video_uploading: '您的视频正在上传中',
  video_success: '上传视频成功!',
  img_success: '图片上传成功!',
  mp3: '只能上传mp3格式!',
  mb30: '上传音频大小不能超过 30M!',
  document_success: '文档上传成功!',
  remove_doc: '确定要移除文档：',
  remove: '移除',
  unsubmission: '你还有题目没有完成，是否继续作答。提交后不可修改',
  continue_answer: '继续作答',
  pay_type: '支付方式',
  pay: '支付',
  qr_code: '请扫描二维码后支付',
  give_up: '放弃购买',
  repayments: '重新支付',
  pay_success: '您已支付成功',
  purchased_course: '已购课程',
  recent_learning: '近期学习',
  schedule: '课表',
  waiting: '待上课',
  completed: '已完成',
  check_the_details: '课程详情',
  no_course_tips: '您暂时还没有课程',
  next_class: '下节课',
  consult_lecturer: '咨询讲师',
  enter_the_classroom: '进入教室',
  playback: '回放',
  practice: '练习',
  broadcasting: '正在直播',
  announcement_details: '公告详情',
  slides_information: '课件资料',
  course_practice: '课程练习',
  view_my_comments: '查看评价',
  watch_the_video: '观看回放',
  enter_tips: '课程开始前15分钟才能进入教室',
  not_yet_started: '暂未开始',
  watch_the_course: '观看课程',
  watch_again: '再次观看',
  unlock_tips: '完成上一节课练习解锁',
  scoring: '评分',
  attitude: '上课态度',
  atmosphere: '课堂氛围',
  contents: '授课内容',
  connection: '网络情况',
  scoring_tips: '您的意见是我们前进的最大动力，对您的配合和支持表示衷心感谢',
  course_briefing: '课程须知',
  chrome_tips1: '为保证上课稳定，上课需要使用谷歌或火狐浏览器，其他浏览器可能会影响上课效果。',
  download_browser: '下载浏览器',
  chrome_tips2: '我们不支持windows XP及以下版本、MAC OS10.11以下版本，如果版本过低，请升级后再上课。',
  cannot_submit_repeatedly: '不可重复提交',
  comment_successful: '评论成功',
  not_over: '未结束',
  study_group: '加入学习群',
  group_tips1: '扫码加入班级群',
  group_tips2: '学习更高效',
  study_report: '学情报告',
  course_completion_rate: '课程完成率',
  practice_completion_rate: '练习完成率',
  report_tips: '您在每节课的课后练习获得的分数如图,随着学习，正确率有没有越来越高呢？',
  report_charts_tips: 'x横轴=课程    Y竖轴=正确率',
  course_details: '课程详情',
  chapter_name: '章节名称',
  status: '状态',
  courseware: '课件',
  operate: '操作',
  class_time: '上课时间',
  not_started: '未开始',
  not_watched: '未观看',
  watched: '已观看',
  file_preview: '附件预览',
  preview_courseware: '预览课件',
  personal_information: '个人资料',
  basic_information: '基本资料',
  security_information: '安全信息',
  gender: '性别',
  grade: '年级',
  revise: '修改',
  go_to_bind: '去绑定',
  unbind: '解绑',
  wechat: '微信',
  female: '女',
  male: '男',
  select_your_grade: '请选择您的年级',
  uploading: '上传中',
  change_password: '修改密码',
  verify_original_password: '验证原密码',
  modify_phone_number: '修改手机号',
  verify_the_original_phone_number: '验证原手机',
  enter_the_new_phone_number: '输入新手机',
  new_phone_code: '请输入新手机号验证码',
  new_password_tips: '请填写新密码',
  same_password_tips: '新密码不能和旧密码相同',
  new_phone_tips: '请填写新手机号码',
  original_password_tips: '请填写原密码',
  please_enter_your_name: '请输入姓名',
  nick_name_limit: '用户名仅限1-15位汉字、数字、大小写字母、下划线',
  complete_the_exercise: '完成练习',
  view_playback: '查看回放',
  please_select_city: '请选择城市',
  img_upload_type_tips: '上传头像图片只能是 JPG 格式 或 PNG 格式！',
  img_upload_size_tips: '上传头像图片大小不能超过3MB！',
  order_details: '订单详情',
  course_order: '课程订单',
  group_chase_order: '团购订单',
  product_name: '商品名',
  selling_price: '售价',
  payment_time: '支付时间',
  order_status: '订单状态',
  paid: '已支付',
  unpaid: '未支付',
  cancelled: '已取消',
  deleted: '已删除',
  to_pay: '去支付',
  order_generation_time: '订单生成时间',
  pay_scan_tips: '请扫描二维码后支付',
  payment_failed: '支付失败',
  pay_fail_tips: '您可以选择重新支付，或者放弃购买',
  abandon_purchase: '放弃购买',
  payment_method: '支付方式',
  choose_payment_method: '请选择支付方式：',
  alipay: '支付宝',
  exchange_center: '兑换中心',
  redemption_enter_tips: '请输入兑换码',
  exchange: '兑换',
  exchange_success_tips: '以下课程已放入您的已购课程',
  course_name: '课程名称',
  check_courses: '查看课程',
  continue_to_redeem: '继续兑换',
  redemption_code_limit: '仅限输入12位兑换码',
  return: '返回',
  no_file_tips: '文件类型暂不支持预览',
  license_post: '讲师资格证展示',
  about_us: '关于我们',
  copyright: '内容版权归属：',
  technical: '伊课提供技术支持',
  information_public: '讲师信息公示',
  teacher_qualification: '教师资格认证公示',
  professional_qualification: '职业资格认证公示',
  professional_level: '职业等级认证公示',
  prev: '上一页',
  next_page: '下一页',
  teaching_license: '教师资格证',
  qualification_certificate: '职业资格证',
  level_certificate: '职业等级证',
  no_certificate: '暂无可公示资格证',
  no_more_data: '没有更多数据了！',
  contact_us: '联系我们',
  no_file_permission_tips: '您无法查看该课件',
  self_test: '课前设备自测',
  start_test: '开始测试',
  all_course: '全部课程',
  course_status: '课程状态',
  course_subject: '课程栏目',
  not_finished: '未完课',
  have_finished: '已完课',
  course_introduce: '课程介绍',
  international_adult_edition: '国际成人版',
  international_youth_edition: '国际青少版',
  chinese_enhanced_edition: '华裔强化版',
  special_training_edition: '专项训练版',
  cultural_interest_edition: '文化兴趣版',
  teaching_research_faculty: '教研师资',
  teaching_research_faculty1: '教研师资',
  to_learn: '去学习',
  been_reg: '（已报名此课程）',
  registered: '已报名',
  no_course_sale1: '暂无在售课程',
  no_tea_info: '暂无讲师介绍',
  tea_info: '讲师介绍',
  course_sale: '在售课程',
  tea_info1: '讲师简介',
  deliveryAddress: '收货地址',
  edit: '编辑',
  addressReminder: '请输入您的收货地址~',
  addressDetailLab: '还没有收货地址？点击设置收货地址',
  order_addressDetailLab: '如有疑问，请电话联系',
  editAddress: '编辑收货地址',
  addAddress: '新增收货地址',
  saveReminder: '您的页面信息还未保存，\n确定返回吗?',
  consignee: '收货人',
  location: '所在地区',
  detailedAddress: '详细地址',
  defaultShippingAddress: '设为默认收货地址',
  saveAddress: '保存地址',
  pleaseSelectRegion: '请选择地区',
  enterRecipient: '请输入收件人',
  enterMobileNumber: '请输入手机号',
  enterRegion: '请输入所在地区',
  enterDetailedAddress: '请输入详细地址',
  enterCorrectMobileNumber: '请输入正确的手机号',
  userNameNumError: '用户名字数不能超过16字，请修改再试',
  addressError: '地址字数不能超过200字，请修改再试',
  savingSucceeded: '保存成功',
  bottomBtn: '+新增收货地址',
  deletAddressTitle: '删除',
  deletAddressMessage: '是否要删除地址',
  operationSucceeded: '操作成功',
  purchaseCourse: '购买课程',
  setDefault: '设为默认',
  myorder: '查看订单',
  defaultAddress: '默认地址',
  selectShippingAddress: '选择收货地址',
  selectAnotherAddress: '选择其他地址',
  trial: '试看',
  free_trial: '免费试看',
  log_in: '请先登录',
  watch: '观看',
  quotaTips: '剩余%template%个名额',
  lessonsCount: '共%template%节',
  freeTrial: '免费试看',
  note_feedback: '通知与反馈',
  open_vip_tip: '开通会员免费享精品课程',
  open_vip: '立即开通',
  exercise: '练习',
  learn: '学习',
  to_be_learned: '待学习',
  issue_ype: '问题类型',
  select_issue: '请选择问题类型',
  issue_content: '请描述您遇到的问题，不少于10个字',
  issue_content_placeholder: '内容不能少于10个字~',
  phone_email1: '手机号/邮箱',
  chang_phone_email: '修改手机号/邮箱',
  verify_current_phone_email: '验证原手机号/邮箱',
  enter_new_phone_email: '输入新手机号/邮箱',
  new_phone_email_code: '请输入新手机号/邮箱验证码',
  download: '下载',
  free_course: '免费下载课程资料',
  completeds: '已学习',
  incomplete1: '未完成',
  submitted: '已提交',
  grade_pending: '老师待批改',
  expired: '已过期',
  playing: '正在播放',
  restart_lesson: '重新学习',
  locked: '未购买',
  exercises: '练习',
  finished: '已完成',
  no_unfinished: '目前没有未完成练习',
  no_finished: '目前没有已完成练习',
  no_expired: '目前没有已过期练习',
  vip_package: '会员套餐',
  my_coupons: '我的优惠券',
  to_be_used: '待使用',
  used: '已使用',
  no_coupons: '暂无优惠券',
  no_min_spend: '无门槛',
  to: '至',
  spend: '满',
  save1: '减',
  off: '折',
  new_users_only: '新用户专享',
  all_items_eligible: '全商品适用',
  selected_items_only: '部分商品适用',
  valid_until: '有效期',
  expires: '有效期至',
  coupon_value: '实付需要大于优惠券金额才可使用',
  use_now: '立即使用',
  got_it: '我知道了',
  no_eligible_courses: '该优惠券暂无适用课程 请使用其它优惠券',
  post_your_articles: '发布文章',
  post_articels: '发布文章',
  my_articels: '我的文章',
  my_likes: '我的点赞',
  my_favorites: '我的收藏',
  my_messages: '互动消息',
  check_schedule: '查看课表',
  forward: '每一道练习题都是你成长的阶梯，',
  grow_stronger: '用心去完成，你会发现自己变得更强大！',
  qty: '题量：',
  total: '总分：',
  no_limits: '无限制',
  incomplete2: '含有未完成的题目，请作答后再提交',
  submit_no_edits: '提交后将无法修改，您确认要提交作业么？',
  practice_complete: '恭喜你完成练习！',
  submission: '提交遇到问题，请尝试重新提交',
  back: '返回',
  analyze: '解析',
  view_practice: '查看练习',
  new_article: '新建文章',
  preview: '文章预览',
  back_to_edit: '返回编辑',
  republish: '重新发布',
  publish: '发布文章',
  title_required: '标题不能为空，请返回编辑',
  content_required: '正文不能为空，请返回编辑',
  select_category: '请选择文章分类，请返回编辑',
  preview1: '预览',
  select_category1: '选择文章分类',
  select_primary: '请选择一级分类',
  select_secondary: '请选择二级分类',
  upload_cover: '上传文章封面',
  px_320: '封面图片尺寸推荐 320*230 （10M以内）',
  only_png: '为更好地推荐内容，请上传格式为JPG、JPEG、PNG图片',
  enable_sharing: '开启后支持文章向外部人员分享查阅',
  enabled: '已开启',
  disabled: '已关闭',
  no_emojis: '暂不支持输入表情',
  title_required1: '标题不能为空',
  content_required1: '正文不能为空',
  words_10000: '文章详情不能超过10000字',
  edit_successful: '编辑成功',
  published: '文章发布成功',
  invalid_format: '上传失败，图片格式有误',
  File_too_large_10: '上传失败，图片大小不能超过10M',
  compression_failed: '图片压缩失败，请重试',
  title_30: '请输入标题（1～30个字）',
  public_access: '对外公开查阅',
  enter: '请输入...',
  publish1: '发布',
  comment1: '评论',
  copy_link: '复制链接',
  weChat_share: '微信扫码分享',
  weChat_share1: '微信分享',
  share: '分享',
  public_access1: '支持对外',
  article_details: '文章详情',
  learners: '人已学习',
  likes: '获赞',
  author_atest: '作者最新文章',
  recommended: '相关推荐',
  refresh: '换一换',
  subscribe: '订阅',
  subscribed: '已订阅',
  unsubscribe: '取消订阅',
  unsubscribed: '已取消订阅',
  confirm_action: '您确定要%template%吗',
  me: '我',
  author: '作者',
  replies: '查看全部%template%条回复',
  comments_yet: '暂无评论，来抢沙发吧',
  sort_by_time: '按时间',
  newest_first: '倒序',
  oldest_first: '正序',
  view_more_comments: '查看更多评论',
  confirm_delete: '你确定要删除该条评论吗？',
  deleted1: '删除成功',
  replied: '回复成功',
  commented: '评论成功',
  say_something: '说点什么吧...',
  delete_image: '删除图片',
  content_required2: '评论内容不得为空',
  words_100001: '评论字数不得超过1万字',
  view_courses: '点击查看课程>>',
  view_articles: '点击查看文章>>',
  my_consultation: '我的咨询',
  archives: '个人档案',
  log: '日志',
  no_cover: '暂无封面',
  published_status: '已发布',
  in_review: '审核中',
  reject: '驳回',
  visits: '访问量',
  like_count: '点赞量',
  collection_quantity: '收藏量',
  number_of_learners: '学习人数',
  number_of_comments: '评论数',
  support_uploading_attachments: '支持上传附件',
  upload_attachments: '上传附件',
  remove_attachments: '移除附件',
  article_max_files_tips: '单篇文章最多支持6个附件',
  document_limit_tips: '文档：xlsx、pptx、docx、ppt、doc、pdf，限制大小:50M',
  image_limit_tips: '图片：jpeg、jpg、png，限制大小:5M',
  audio_limit_tips: '音频：mpeg、mp3，限制大小:100M',
  video_limit_tips: '视频：mp4，限制大小：200M',
  no_emoji_tips: '暂不支持输入表情',
  image_type_error: '上传失败，请选择图片格式文件',
  image_size_error: '上传失败，图片大小不能超过10M',
  my_classroom_rating: '我的课堂评分',
  close: '关闭',
  scoring_table: '评分表'
}
export default lang



// WEBPACK FOOTER //
// ./src/global/cnLang.js